<template>
  <div>
    <div v-if="covers.length" class="image-box">
      <router-link v-for="(c, i) in covers" :key="i" :to="c.path">
        <img :src="c.image" :alt="c.alt || ''" class="image" />
      </router-link>
    </div>

    <div v-else-if="author" class="wrapper">
      <img :src="image" :alt="alt" class="author-image" />
    </div>
    <img v-else :src="image" :alt="alt" class="image" />
  </div>
</template>

<script>
export default {
  name: "ImageBox",
  props: {
    image: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: "",
    },
    covers: {
      type: Array,
      default: () => [],
    },
    author: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.image-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.image {
  flex-shrink: 1;
  margin: 0.5em;
  padding: 0.5em;
  max-width: 350px;
  height: auto;
  max-height: 475px;
  transition: transform 0.3s ease;
}
.image:hover {
  transform: scale(1.02);
}
.author-image {
  max-width: 80%;
  display: block;
}
.wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 1024px) {
  .image-box {
    max-width: 100%;
  }
  .image {
    max-width: 275px;
    max-height: 400px;
  }
}
@media (max-width: 890px) {
  .image-box {
    max-width: 100%;
  }
  .image {
    max-width: 250px;
    max-height: 350px;
  }
}
@media (max-width: 768px) {
  .image-box {
    max-width: 100%;
  }
  .image {
    width: 200px;
    max-height: 300px;
  }
  .wrapper {
    justify-content: center;
  }
}
@media (max-width: 700px) {
  .image-box {
    display: flex;
    flex-direction: column;
  }
  .image {
    display: block;
    margin: 0 auto;

    max-width: 60%;
    max-height: 100%;

    width: auto;
    height: auto;

    object-fit: contain;
  }
}
@media (max-width: 480px) {
  .image-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: auto;

    width: 100%;
    overflow: hidden;
  }

  .image {
    display: block;
    margin: 0 auto;

    max-width: 95%;
    max-height: 100%;

    width: auto;
    height: auto;

    object-fit: contain;
  }

  .wrapper {
    justify-content: center;
  }
}
</style>
